import { Badge, SxProps, Theme } from '@mui/material';
import useDevice from 'hooks/DesktopDevice.hook';
import mobile from 'is-mobile';
import { FC, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Tooltip } from 'styles';
import ListItem from 'styles/list/ListItem';
import ListItemButton from 'styles/list/ListItemButton';
import ListItemIcon from 'styles/list/ListItemIcon';
import ListItemText from 'styles/list/ListItemText';
import Typography from 'styles/typography/Typograpy';
import { IAction } from 'utils/links';

type ListButtonProps = {
	onClick: () => void;
	action: IAction;
	open: boolean;
	sx?: SxProps<Theme>;
	notifications?: number;
};

const ListItemButtonCust: FC<ListButtonProps> = props => {
	const { open, onClick, action, sx = {}, notifications } = props;
	const location = useLocation();
	const [openTooltip, setOpenTooltip] = useState(false);
	const { isDesktop } = useDevice();
	const isMobile = mobile({ tablet: true, featureDetect: true });

	const handlerClick = () => {
		if (openTooltip) {
			setOpenTooltip(false);
		}
		onClick();
	};

	const handleClose = () => {
		setOpenTooltip(false);
	};

	const handleOpen = () => {
		setOpenTooltip(true);
	};

	return (
		<ListItem disablePadding sx={{ display: 'block' }}>
			<ListItemButton
				onMouseEnter={handleOpen}
				onMouseLeave={handleClose}
				sx={{
					minHeight: 0,
					justifyContent: open ? 'initial' : 'center',
					p: 0,
					mr: open ? 1.5 : 'auto',
					...sx,
				}}
				onClick={handlerClick}
			>
				<Tooltip
					open={!open && !isMobile ? openTooltip : false}
					disableTouchListener
					title={action.name}
					placement="right"
				>
					<Box display="flex">
						<Badge badgeContent={notifications} color="error" overlap="circular">
							<ListItemIcon
								sx={{
									minWidth: 0,
									mr: open ? 3 : 'auto',
									justifyContent: 'center',
									px: !isDesktop ? 0.5 : 0,
								}}
							>
								{location.pathname.includes(action.link)
									? action.icon
									: action.unselected_route || action.icon}
							</ListItemIcon>
						</Badge>
					</Box>
				</Tooltip>
				<ListItemText sx={{ opacity: open ? 1 : 0, ml: !!isDesktop ? -1 : -1.875 }}>
					<Typography
						variant="bodyLink"
						sx={{
							color: location.pathname.includes(action.link)
								? 'primary.main'
								: 'grey3.main',
						}}
					>
						{action.name}
					</Typography>
				</ListItemText>
			</ListItemButton>
		</ListItem>
	);
};

export default ListItemButtonCust;
